/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} GermanInputs */



/**
* | output |
* | --- |
* | "Deutsch" |
*
* @param {GermanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const german = /** @type {((inputs?: GermanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<GermanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deutsch")
	if (locale === "de") return /** @type {LocalizedString} */ ("Deutsch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tedesco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("немецкий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alemán")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("德语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドイツ語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("deutsch")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alemão")
	return /** @type {LocalizedString} */ ("Deutsch")
});